import { Helpers } from '../core/src/helpers';
import { EtrAPI } from '../core/src/etr-api-client';

// export const RECEIVE_CART = 'RECEIVE_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const MANAGE_ORDER_LOCK = 'MANAGE_ORDER_LOCK';
export const TOGGLE_SERVICE_TIMEOUT = 'TOGGLE_SERVICE_TIMEOUT';
export const RECEIVE_UTILITY = "RECEIVE_UTILITY";
export const RECEIVE_USER_IDLE = "RECEIVE_USER_IDLE";
export const LAUNCH_CART_FLYOUT = "LAUNCH_CART_FLYOUT";
export const CLOSE_CART_FLYOUT = 'CLOSE_CART_FLYOUT';

//helper function to try to initialize pStoreID on client side
//this is to help avoid flicker on above the file components that are private store specific
//since we can't authenticate on server side we assume that if the pStoreID is in the url then they belong to that private store
const getPrivateStoreID = () => {
	let pStoreID;
	try {
		pStoreID = Helpers.getSearch(window.location.search).pStoreID;
	} catch (e) { }
	return pStoreID;
};

export const NULL_UTIL_STATE = {
	profileData: {
		personData: {
			userType: 'G',
			userTier: 'GS',
			pStoreID: getPrivateStoreID(),
		},
		labels: {
			cutomerService: 'Customer Service',
			lblSignin: 'Sign in',
			lblRegister: 'Register',
			orderStatus: 'Order Status',
			lblSigninRegister: 'Sign in/Register',
			liveHelp: 'Live Help',
			lblMyOrders: 'My orders',
			customerCarePhone:
				'&lt;!-- BEGIN CustomerPhoneContentRecommendation.jsp --&gt;1-800-407-4005&lt;!-- END CustomerPhoneContentRecommendation.jsp --&gt;',
		},
		newsletterSubsribeUrl:
			`${process.env.BASENAME}/ManageSubscription?catalogId=10051&amp;langId=-1&amp;storeId=10151`,
		hpRewardsUrl:
			`${process.env.BASENAME}/LoadLoyaltyLandingPageCmd?catalogId=10051&amp;userTyp=G&amp;storeId=10151`,
		homeUrl: process.env.BASENAME,
		isccf: false,
	},
	callCenter: {},
	serviceTimeout: null,
	userIdle: false,
	cartData: {},
	updatedFromService: false
};

export const receiveOrderLock = (orderLock) => ({
	type: MANAGE_ORDER_LOCK,
	orderLock
});

export const receiveCart = (actionType, cartData = NULL_OBJECT, product, qty, addOns, baseProductSku, xsellType) => {
	return {
		type: actionType,
		cartData,
		product,
		baseProductSku,
		xsellType,
		qty,
		addOns,
	}
}
export const receiveUserIdle = (userIdle) => ({
	type: RECEIVE_USER_IDLE,
	userIdle
});

export const receiveUtility = (utilityInfo, updatedFromService) => ({
	type: RECEIVE_UTILITY,
	utilityInfo,
	updatedFromService
});

export const toggleServiceTimeout = (toggle) => {
	return {
		type: TOGGLE_SERVICE_TIMEOUT,
		toggle
	}
}

export const launchCartFlyout = () => ({
	type: LAUNCH_CART_FLYOUT
})

export const closeCartFlyout = () => ({
	type: CLOSE_CART_FLYOUT
})

export const setUserIdle = (userIdle) => (dispatch, getState) => {
	const { userData } = getState();

	if (userData.userIdle !== userIdle) {
		return dispatch(receiveUserIdle(userIdle));
	}
}

export const fetchProfileAndCart = () => dispatch => {
	return EtrAPI.services.fetchProfileAndCart().then(resp => {
		let utilityInfo = resp.status == "200" ? resp.data : { ...NULL_UTIL_STATE };
		return dispatch(receiveUtility(utilityInfo, true));
	}).catch((e) => {
		//if this fails dispatch the null state so we will at least track metrics
		// because page view in metrics middleware looks for this event 
		// as UDL waits for user info to be received
		return dispatch(receiveUtility({ ...NULL_UTIL_STATE }));
	});
};

export const fetchCart = (actionType, product, qty, blockFlyout, addOns, baseProductSku, xsellType) => dispatch => {
	return EtrAPI.services.fetchCart().then(resp => {
		if (resp.status == "200") {
			let cartData = resp.data.cartData;
			return dispatch(receiveCart(actionType, cartData, product, qty, addOns, baseProductSku, xsellType));
		}
	})
}

// this list of params keep growing, should we just pass the product object ?
export const updateCart = (cartItem, curQty) => dispatch => {
	let { id, qty } = cartItem;
	if (curQty > 0) {
		return EtrAPI.cart.updateCartItem(id, curQty).then(resp => {
			if (resp.status == "200") {
				dispatch(fetchCart(UPDATE_CART, cartItem, curQty));
			}
		})
	} else {
		return EtrAPI.cart.deleteCartItem(id).then(resp => {
			if (resp.status == "200") {
				curQty = qty;
				dispatch(fetchCart(REMOVE_FROM_CART, cartItem, curQty));
			}
		})
	}

}

// helper function to add eCarepack option
const _addElgblSku = (sku = "", index = null) => {
	return { elgblSku: encodeURIComponent(`SKU=${sku}`), index };
};

/**
 * Add multiple product to cart in a single call
 * @param  {[Array]}   products    [Array of string ids or product Objects]
 * @param  {[Array]}   qty         [Parallel array of quantity]
 * @param  {[Boolean]} blockFlyout [Block cart fly out after add to cart action]
 * @param  {[Object]}  options     [additional options to send with add to cart function]
 * @param  {[String]}  baseProductSku [Base product sku for xsell products, needed only for xsell products]
 * @param  {[String]}  xsellType   [xsell modal type used when adding xsell products to cart, needed only for xsell products]
 * @return {[Promise]}
 */
export const addMultipleToCart = (products, qty, blockFlyout, options = {}, baseProductSku, xsellType) => dispatch => {
	// initialize eCarepack option
	options.eCarepack = [];

	let id = products.reduce((ids, p, i) => {
		if (typeof p === 'string') {
			ids.push(p);
		} else {
			ids.push(p.itemId);
			if (Helpers.isECarepack(p)) {
				options.eCarepack.push(_addElgblSku(options.baseSKU, i));
			}
		}
		return ids;
	}, []);

	return EtrAPI.cart.addToCart(id, qty, options).then(resp => {
		if (resp.status == "200") {
			let data = JSON.parse(resp.data.split('*')[1]);
			if (data.errorMessage) {
				alert(data.errorMessage);
			} else {
				dispatch(fetchCart(ADD_TO_CART, products, qty = 1, blockFlyout, null, baseProductSku, xsellType));
			}

		}
	})
}

/**
 * Add product to cart
 * @param  {[Object]}  product      [The primary product to be added to cart]
 * @param  {[Number]}  qty          [The quantity to add for the primary product]
 * @param  {[Boolean]} blockFlyout  [Boolean to block cart flyout after add to cart]
 * @param  {[Array]}   addOns       [Array of additional products to be added to cart, Format: [{ product: Object, qty: Number},]
 * @param  {[Object]}  options      [additional options, use for things like giftcards, xsell base product]
 * @param  {[String]}  baseProductSku [Base product sku for xsell products, needed only for xsell products]
 * @param  {[String]}  xsellType   [xsell modal type used when adding xsell products to cart, needed only for xsell products]
 * @return {[Promise]}            
 */

/*baseProductSku and xsellType are optional params dedicated for xsell CTA tracking, they only apply to situations where a xsell product being added via a xsell module*/
export const addToCart = (
	product, qty = 1, blockFlyout, addOnProducts,
	options = {}, baseProductSku, xsellType) => (dispatch, getState) => {
		let id;
		const isESKU = Helpers.isECarepack(product);
		options.eCarepack = [];
		const { productData } = getState();
		let { addOns = {} } = productData;

		//own prop addOns take priority over addons from redux state
		addOns = addOnProducts && addOnProducts.length > 0 ? addOnProducts : addOns[product.sku];

		// check if eCarepack is added as main product
		if (isESKU && (options.baseSKU || options.userInputBaseSKU)) {
			options.eCarepack.push(
				options.userInputBaseSKU ?
					{ elgblSku: options.userInputBaseSKU } : _addElgblSku(options.baseSKU));
		};

		if (addOns && addOns.constructor === Array) {
			// reduce addons to parallel arrays of itemId and qty
			let { addOnId, addOnQty } = addOns.reduce((result, ao, i) => {
				const itemId = ao.product.itemId;
				const aoQty = ao.qty;
				const isECP = Helpers.isECarepack(ao.product);

				if (isECP) {
					options.eCarepack.push(_addElgblSku(product.sku, i))
				}

				result.addOnId.push(itemId);
				result.addOnQty.push(aoQty);

				return result;
			}, { addOnId: [], addOnQty: [] });

			id = [...addOnId, product.itemId]
			qty = [...addOnQty, qty];
		} else {
			id = product.itemId;
		}

		return EtrAPI.cart.addToCart(id, qty, options).then(resp => {
			if (resp.status == "200") {
				let data = JSON.parse(resp.data.split('*')[1]);
				if (data.errorMessage) {
					alert(data.errorMessage);
					return Promise.reject();
				} else {
					return dispatch(fetchCart(ADD_TO_CART, product, qty = 1, blockFlyout, addOns, baseProductSku, xsellType));
				}
			}
		});
	}

/**
 * Add cto preconfig to cart
 * @param  {[Object]}  product      [The primary product to be added to cart]
 * @param  {[Number]}  qty          [The quantity to add for the primary product]
 * @param  {[Boolean]} blockFlyout  [Boolean to block cart flyout after add to cart]
 * @return {[Promise]}            
 */
export const addCTOToCart = (product, qty, blockFlyout = true, followRedirect = true) => (dispatch, getState) => {
	const { itemId } = product;
	const { productData } = getState();
	const { productInfo } = productData;
	const { productPrices } = productInfo;
	const priceData = productPrices[product.sku] || {};
	const { ctoLink } = priceData;
	return EtrAPI.cto.addPreConfig(itemId).then((resp) => {
		if (!resp) {
			return Promise.reject();
		}
		return dispatch(fetchCart(ADD_TO_CART, product, qty = 1, blockFlyout))
			.then(() => {
				if (!followRedirect) {
					return;
				}
				if (resp.redirecturl != undefined && resp.redirecturl == 'AccessoryAttachView') {
					document.location.href = `${process.env.BASENAME}/${resp.redirecturl}?shipDate=${encodeURIComponent(resp.shipDate)}&selectedRecommConfig=recConfig1&catEntryId=${itemId}&storeId=10151`;
				}
				else if (resp.redirecturl != undefined && resp.redirecturl == 'AjaxOrderItemDisplayView') {
					document.location.href = `${process.env.BASENAME}/${resp.redirecturl}?storeId=10151&catalogId=10051&langId=-1`;
				}
				else {
					let params = {}
					if (typeof (a2Cdata.dl) != 'undefined' && a2Cdata.dl === "true") {
						params.dl = 'true'
					}
					if (ctoLink) {
						document.location.href = ctoLink;
					}
				}
			})
			.catch((e) => {
				if (!followRedirect) {
					return;
				}
				if (ctoLink) {
					document.location.href = ctoLink;
				}
			});
	});
}

export const manageOrderLock = (ccAction) => dispatch => {
	return EtrAPI.callCenter.manageOrderLock(ccAction).then(resp => {
		try {
			resp = resp.data.replace("/*", "").replace("*/", "").trim();
			resp = JSON.parse(resp);
			if (resp && resp.isSuccess === "Y") {
				resp.message = "Cart is now " + (resp.lockAction === "A" ? "locked" : "unlocked");
			} else {
				//standardize the response in message
				resp.message = resp.errorMessage;
				resp.errorMessageKey = resp.errorMessageKey || "EXCEPTION";
			}

			dispatch(receiveOrderLock(resp));
		} catch (e) {
			dispatch(receiveOrderLock({
				"message": "Failed to perform the requested operation. Retry.",
				"errorMessageKey": "EXCEPTION"
			}));
		}
	});
}